import React from "react";
import Settings from "../pages/Settings";
import Page from "./Page";

export default function SettingsContainer(props: any) {
    return (
        <Page Body={() => <Settings {...props} />} />
    )
}